import cn from 'classnames';
import { Link, LinkProps } from 'react-router-dom';

import styles from './index.module.sass';
import { useRef } from 'react';
import { Circle } from '@ui/icons';

export function HomeCard(props: IHomeCardProps) {
  const { className, title, icon, icons, description, link, ...rest } = props;
  const rootClass = cn(className, styles.root);
  return (
    <Link className={rootClass} to={link} {...rest}>
      <div className={styles.rotator}>{Circle()}</div>
      <div className={styles.icon}>{icons ? icons.map((icon) => icon) : icon}</div>
      <div className={styles.title}>{title}</div>
    </Link>
  );
}

export interface IHomeCardProps extends Omit<LinkProps, 'to'> {
  title: string;
  description?: string | React.ReactNode;
  link: string;
  icon: React.ReactNode;
  icons?: Array<React.ReactNode>;
}
